import { QTask } from '@qwealth/qdata';
import InfoTag from '../SectionHeader/InfoTag';
import { ACTIVITY_TYPE_TASKS, ActivityType } from 'data/models/Activity';

interface getTagsProps {
  type: ActivityType;
  taskData: Partial<QTask> | null;
}

export const getActivityTags = ({ type, taskData }: getTagsProps): React.ReactElement[] => {
  const tags: React.ReactElement[] = [];

  switch (type) {
    case ACTIVITY_TYPE_TASKS:
      if (taskData) {
        taskData.isRecurring && tags.push(<InfoTag tagTitle="Recurring" icon="Recurring" fontSize="sectionTitle" />);
        taskData.lastUpdatedByWealthbox && tags.push(<InfoTag tagTitle="Wealthbox" fontSize="sectionTitle" />);
      }
      break;
    default:
      break;
  }

  return tags;
};
